module.exports = __webpack_public_path__ + "static/img/12.ea14235.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/zh/12.png
// module id = wruH
// module chunks = 0